import React from 'react';
import { Modal } from '../../components/Modal/Modal';
import { Button, WebpImageWithFallback } from '@husslehq/ui-library';

import styles from '../../components/ImageList/ImageList.module.scss';

export interface IGalleryImage {
  original: string;
}

export type ImageListProps = {
  galleryData: IGalleryImage[];
  onClose: () => void;
  modalVisible: boolean;
  gymName: string;
};

export const ImageList: React.FC<ImageListProps> = ({ galleryData, onClose, modalVisible, gymName }) => {
  return (
    <>
      <Modal
        visible={modalVisible}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        onRequestClose={onClose}
        overlayClassName="image-list-modal-overlay"
        modalClassName="image-list-modal"
        contentClassName={styles['image__modal-content']}
      >
        <div className={styles['image__back-container']}>
          <Button level="outline" className={styles['image__back-btn']} onClick={onClose}>
            Back to Gym Details
          </Button>
        </div>
        <ul className={styles.image__list}>
          {galleryData.map((image, idx) => (
            <li key={'image-' + idx}>
              <WebpImageWithFallback
                alt={'Photo of ' + gymName}
                className={styles['image__img']}
                src={image.original}
                loading="eager"
                width="385"
                height="265"
              />
            </li>
          ))}
        </ul>
      </Modal>
    </>
  );
};

export { ImageList as default };
